export default "/images/vendor/flag-icons/flags/1x1/kg.svg?29765023c004eaa513400fe43ac39bc2";